import React from 'react';
import { Alert, Button, Tag } from 'antd';
import { OperationalVersionLoad } from './display';

interface EvidenceMutationFieldsProps {
    allowMutations: boolean;
    children: React.ReactNode;
}

/** Upload and save controls for activity evidence. Omitted entirely when the version is not editable. */
export const EvidenceMutationFields: React.FC<EvidenceMutationFieldsProps> = ({ allowMutations, children }) => {
    if (!allowMutations) {
        return (
            <div>
                <h3>Archivos</h3>
                <Tag>Solo lectura</Tag>
            </div>
        );
    }
    return <>{children}</>;
};

interface OperationalMutationSlotProps {
    allowMutations: boolean;
    children: React.ReactNode;
}

/** Row and toolbar mutations. Hidden until the version state is known and the version is editable. */
export const OperationalMutationSlot: React.FC<OperationalMutationSlotProps> = ({ allowMutations, children }) => {
    if (!allowMutations) return null;
    return <>{children}</>;
};

interface OperationalVersionLoadAlertProps {
    load: OperationalVersionLoad;
    onRetry: () => void;
}

export const OperationalVersionLoadAlert: React.FC<OperationalVersionLoadAlertProps> = ({ load, onRetry }) => {
    if (load !== 'error') return null;
    return (
        <Alert
            type="error"
            showIcon
            style={{ marginBottom: 12 }}
            message="No se pudo cargar el estado de la versión."
            action={<Button size="small" onClick={onRetry}>Reintentar</Button>}
        />
    );
};
